import React from 'react';
import { Chip, Link } from '@mui/material';
import PropTypes from 'prop-types';

function chipColorFor(kind) {
  if (kind === 'responded') return 'responded';
  if (kind === 'ltfu') return 'ltfu';
  return 'fu';
}

export function FuTag({ label, kind = 'fu', frontUrl = null }) {
  if (!label) return null;
  const chip = (
    <Chip
      size="small"
      color={chipColorFor(kind)}
      label={label}
      data-testid="onyx-fu-tag"
    />
  );
  if (!frontUrl) return chip;
  return (
    <Link href={frontUrl} target="_blank" rel="noopener noreferrer" underline="none">
      {chip}
    </Link>
  );
}

FuTag.propTypes = {
  label: PropTypes.string,
  kind: PropTypes.oneOf(['fu', 'responded', 'ltfu', 'idv']),
  frontUrl: PropTypes.string,
};
